import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import styled from 'styled-components';
import ControlWithLabel from './ControlWithLabel';
import { PLACEHOLDER_SELECT } from '../../constants/cmConstants';

const DropDown = ({
  value,
  onChange,
  options,
  label,
  isSearchable,
  className,
  isDisabled,
  placeholder,
  allowClear
}) => {
  return (
    <ControlWithLabel label={label} className={className}>
      <StyledSelect
        showSearch={isSearchable}
        optionFilterProp="children"
        value={value}
        onChange={onChange}
        placeholder={placeholder ? placeholder : PLACEHOLDER_SELECT}
        size="small"
        allowClear={allowClear}
        disabled={isDisabled}>
        {options.map(({ label, value }) => {
          return (
            <Select.Option key={value} value={value}>
              {label}
            </Select.Option>
          );
        })}
      </StyledSelect>
    </ControlWithLabel>
  );
};

const StyledSelect = styled(Select)`
  &&&.ant-select-open,
  &&&:not(.ant-select-disabled):hover {
    .ant-select-selector {
      border-color: #21b4bd;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
    }
  }
`;

DropDown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  isSearchable: PropTypes.bool,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.string,
  allowClear: PropTypes.bool
};

DropDown.defaultProps = {
  options: [],
  isSearchable: false,
  isDisabled: false,
  allowClear: false
};

export default DropDown;
